import React, { useState } from "react";
import BusinessDetails from "./businessDetails";
import BusinessMonthlyReport from "./BusinessMonthlyRepport";
import { useSelector } from "react-redux";
import { selectState } from "../../store/slices/themeSlice";
import useCustomStyles from "../../hooks/useCustomStyles";
import { accessCodesStyles } from "../../assets/styles/accessCodesStyles";
import { useParams } from "react-router-dom";

type TabKey = "details" | "monthlyReport";

const BusinessDetailsTabs: React.FC = () => {
  const { id: businessId } = useParams<{ id: string }>();
  const { theme } = useSelector(selectState);
  const classes = useCustomStyles(accessCodesStyles, theme);
  const [activeTab, setActiveTab] = useState<TabKey>("details");

  const primaryColor = theme?.colorSchema?.colors?.primary || "#2196F3";

  const tabStyle = (tab: TabKey): React.CSSProperties => ({
    padding: "10px 20px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: 500,
    border: "none",
    background: "none",
    borderBottom: activeTab === tab ? `2px solid ${primaryColor}` : "2px solid transparent",
    color: activeTab === tab ? primaryColor : "#666",
    transition: "color 0.15s, border-color 0.15s",
  });

  return (
    <div className={classes.container} style={{ padding: "20px", maxWidth: "1000px", margin: "0 auto" }}>
      <div style={{ display: "flex", gap: "8px", borderBottom: "1px solid #eee", marginBottom: "20px" }}>
        <button style={tabStyle("details")} onClick={() => setActiveTab("details")}>
          Business Details
        </button>
        <button style={tabStyle("monthlyReport")} onClick={() => setActiveTab("monthlyReport")}>
          Monthly Report
        </button>
      </div>

      {activeTab === "details" && <BusinessDetails businessId={businessId} />}
      {activeTab === "monthlyReport" && businessId && <BusinessMonthlyReport businessId={businessId} />}
    </div>
  );
};

export default BusinessDetailsTabs;